import { text } from "../constants/tailwind-theme";
import { twMerge } from 'tailwind-merge'
import React from "react";


const SelectTicketCard = (props) => {

    const { ticket_name, ticket_remaining, ticket_description , ticket_cost } = props.item;
    const { index, selectedIndex } = props;

    const [isSoldOut , setIsSoldOut] = React.useState("")
    return (
        <div onClick={()=>{ props.onClick(props.index)}} className="flex flex-row border border-tertiary-400">
            {/* radio button */}
            <div className="relative">
                <input checked={index===selectedIndex} className="absolute m-4 border-2" name="ticket"  type="radio"  id="" />
            </div>

            {/* remaining tickets */}
            <div className="flex flex-col justify-start items-center w-8/12 border-0">
                <div className={`flex justify-center items-center h-7 w-24 rounded-b-lg mb-1  `+ (ticket_remaining===0 ? "bg-tertiary-400":"bg-primary-500") }>
                    <p className={twMerge(`${text.description1} text-white font-medium text-center`)}>{ticket_remaining===0 ? "SOLD OUT" : ticket_remaining +" LEFT" } </p>
                </div>
                <h1 className={twMerge(`${text.heading1} mb-1 text-center`)}>{ticket_name} </h1>
                <p className={twMerge(`${text.description1} text-tertiary-400 mb-8 text-center`)}>{ticket_description} </p>
            </div>

            {/* PRICE */}
            <div className="flex items-center justify-center bg-tertiary-300 p-4 w-4/12 ">
                <h2 className={twMerge(`${text.heading2}`)}>GHC {ticket_cost}</h2>
            </div>
        </div>
    )
}

export default SelectTicketCard;